import translations from './translations'

translations.add('is', {
    threeDigitsDescription: 'Þrír tölustafir á hægri bakhlið kortsins',
    fourDigitsDescription: 'Fjórir tölustafir að framan til hægri',
    cvcCode: 'CSC/CVV'
})
